<template>
    <div>
        <h1>Develop a process for clear and transparent reporting</h1> 
                                     
        <div id="compass1920">
            <audio ref="audio33" @timeupdate="onTimeUpdate" controls class="compass" id="audio33" :src="baseurl + 'assets/audios/camp2-compass1920.mp3'"></audio>

            <div class="overemphasis">
                <div class="animation animation1">
                    <div class="three-circle">
                        <div class="circle family"></div>
                        <div class="circle business"></div>
                        <h2 class="family">Family</h2>
                        <h2 class="business">Business</h2>
                    </div>

                    <h2 id="consequence-title">Erodes in the business:</h2>

                    <div id="consequences1">
                        <div id="communications1" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Communications</h3>
                        </div>
                        <div id="relations1" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Relations</h3>
                        </div>
                        <div id="performance1" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Performance Appraisals</h3>
                        </div>
                        <div id="decision1" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Decision Making</h3>
                        </div>
                        <div id="strategic1" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Strategic Options</h3>
                        </div>
                    </div>

                    <p class="source">Source: T. Hubler and G. Ayres</p>
                </div>

                <div class="animation animation2" style="display: none;">
                    <div class="three-circle">
                        <div class="circle family"></div>
                        <div class="circle business"></div>
                        <h2 class="family">Family</h2>
                        <h2 class="business">Business</h2>
                    </div>

                    <h2 id="consequence-title">Erodes in the family:</h2>

                    <div id="consequences2">
                        <div id="communications2" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Communications</h3>
                        </div>
                        <div id="identification2" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Identification</h3>
                        </div>
                        <div id="loyalty2" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Loyalty</h3>
                        </div>
                        <div id="emotions2" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Emotions</h3>
                        </div>
                        <div id="family-time2" class="consequence">
                            <div class="icon"><span></span></div>
                            <h3>Family Time</h3>
                        </div>
                    </div>
                    <p class="source">Source: T. Hubler and G. Ayres</p>
                </div>
            </div>
        </div>
    </div>
</template>




<script>

export default {
    name: "audio1",
    components: {},
    data() {
        return {
            currentTime: 0,
            aniStep: [0,0,0,0,0,0,0,0,0,0,0,0]
        };
    },
    props: {
        model: {},
    },
    computed: { },
    methods: {
        onTimeUpdate () {
            this.currentTime =  Math.round(this.$refs.audio33.currentTime);
                

            if (this.currentTime >= 5 && this.aniStep[0] == 0) {
                this.aniStep[0] = 1;
                document.querySelector("#compass1920 .animation1 div.circle.family").animate({width: '400px', height: '400px', left: '-145px', top: '-15px'}, {duration: 2100, queue:false});
                document.querySelector("#compass1920 .animation1 h2.family").animate({fontSize: '45px', left: '-70px', top: '145px'}, {duration: 2100, queue:false});
            }

            if (this.currentTime >= 7 && this.aniStep[1] == 0) {
                this.aniStep[1] = 1;

                document.querySelector("#compass1920 .animation1 div.circle.family").setAttribute("style", "width: 400px; height: 400px; left: -145px; top: -15px;");
                document.querySelector("#compass1920 .animation1 h2.family").setAttribute("style", "font-size: 45px; left: -70px; top: 145px;");

                document.querySelector("#compass1920 #communications1 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #communications1 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #communications1 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #communications1 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications1 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications1 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications1 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications1 div.icon"), 0, 300, 0);
                }, 1200);
            }

            if (this.currentTime >= 9 && this.aniStep[2] == 0) {
                this.aniStep[2] = 1;
                document.querySelector("#compass1920 #relations1 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #relations1 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #relations1 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #relations1 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #relations1 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #relations1 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #relations1 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #relations1 div.icon"), 0, 300, 0);
                }, 1200);
            }

            if (this.currentTime >= 11 && this.aniStep[3] == 0) {
                this.aniStep[3] = 1;
                document.querySelector("#compass1920 #performance1 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #performance1 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #performance1 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #performance1 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #performance1 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #performance1 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #performance1 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #performance1 div.icon"), 0, 300, 0);
                }, 1200);
            }

            if (this.currentTime >= 13 && this.aniStep[4] == 0) {
                this.aniStep[4] = 1;
                document.querySelector("#compass1920 #decision1 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #decision1 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #decision1 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #decision1 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #decision1 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #decision1 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #decision1 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #decision1 div.icon"), 0, 300, 0);
                }, 1200);
            }

            if (this.currentTime >= 15 && this.aniStep[5] == 0) {
                this.aniStep[5] = 1;
                document.querySelector("#compass1920 #strategic1 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #strategic1 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #strategic1 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #strategic1 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #strategic1 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #strategic1 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #strategic1 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #strategic1 div.icon"), 0, 300, 0);
                }, 1200);

            }
        
            if (this.currentTime >= 19 && this.aniStep[6] == 0) {
                document.querySelector("#compass1920 .animation1").setAttribute("style", "display: none");
                document.querySelector("#compass1920 .animation2").setAttribute("style", "display: block");

                this.aniStep[6] = 1;

                document.querySelector("#compass1920 .animation2 div.circle.business").animate({width: '400px', height: '400px', left: '165px', top: '-15px'}, {duration: 2100, queue:false});
                document.querySelector("#compass1920 .animation2 h2.business").animate({fontSize: '45px', left: '250px', top: '145px'}, {duration: 2100, queue:false});

                document.querySelector("#compass1920 #communications2 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #communications2 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #communications2 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #communications2 div.icon"), 15, 300, 0);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications2 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications2 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications2 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #communications2 div.icon"), 0, 300, 0);
                }, 1200);
                
            }

            if (this.currentTime >= 21 && this.aniStep[7] == 0) {
                this.aniStep[7] = 1;

                document.querySelector("#compass1920 .animation2 div.circle.business").setAttribute("style", "width: 400px; height: 400px; left: 165px; top: -15px;");
                document.querySelector("#compass1920 .animation2 h2.business").setAttribute("style", "font-size: 45px; left: 250px; top: 145px;");

                document.querySelector("#compass1920 #identification2 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #identification2 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #identification2 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #identification2 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #identification2 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #identification2 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #identification2 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #identification2 div.icon"), 0, 300, 0);
                }, 1200);

            }

            if (this.currentTime >= 23 && this.aniStep[8] == 0) {
                this.aniStep[8] = 1;
                document.querySelector("#compass1920 #loyalty2 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #loyalty2 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #loyalty2 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #loyalty2 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #loyalty2 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #loyalty2 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #loyalty2 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #loyalty2 div.icon"), 0, 300, 0);
                }, 1200);

            }

            if (this.currentTime >= 24 && this.aniStep[9] == 0) {
                this.aniStep[9] = 1;
                document.querySelector("#compass1920 #emotions2 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #emotions2 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #emotions2 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #emotions2 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #emotions2 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #emotions2 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #emotions2 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #emotions2 div.icon"), 0, 300, 0);
                }, 1200);

            }

            if (this.currentTime >= 26 && this.aniStep[10] == 0) {
                this.aniStep[10] = 1;
                document.querySelector("#compass1920 #family-time2 div.icon span").setAttribute("style", "width: 47px");
                document.querySelector("#compass1920 #family-time2 div.icon span").animate({height: "47px"}, {duration: 500, queue: false});

                setTimeout(function() {
                    document.querySelector("#compass1920 #family-time2 div.icon span").setAttribute("style", "width: 47px; height: 47px;");
                }, 500);

                rotateElement(document.querySelector("#compass1920 #family-time2 div.icon"), 15, 300, 0);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #family-time2 div.icon"), -15, 300, 0);
                }, 300);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #family-time2 div.icon"), 15, 300, 0);
                }, 600);

                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #family-time2 div.icon"), -15, 300, 0);
                }, 900);
                
                setTimeout(function() {
                    rotateElement(document.querySelector("#compass1920 #family-time2 div.icon"), 0, 300, 0);
                }, 1200);

            }
        }
    }
}

</script>